import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { FC } from "react";
import svgIcons from "../../../assets/svg/svgIcons";
import { useTranslation } from "react-i18next";
import { ICCHistory } from "../../../api/types/CamerasAdminVM";
import AdminTable from "../../../components/adminTable";
import { TAdminTableRowData } from "../../../components/types";
import { useAccountTimezone } from "../../../hooks/timezone";
import {
  dbTimeToJsTime,
  formattedDateTimeBasedOnTimezone,
} from "../../../utils/dateTime";
import { APP_CONFIG } from "../../../constants/constants";

type ModalICCHistoryProps = {
  historyData: ICCHistory[];
};

const ModalICCHistory: FC<ModalICCHistoryProps> = ({ historyData }) => {
  const { t } = useTranslation();
  const { tzForDateFns } = useAccountTimezone();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showModalVMICChistory: false }));
  };

  const all_columns = ["SIM Type", "ICCID", "First Detected"];
  const columns = all_columns.map((colItem, _) => {
    return {
      name: colItem,
      show: true,
    };
  });

  //table data
  const tableData: TAdminTableRowData[] = !!historyData
    ? (historyData || []).map((item, index) => ({
        navLink: "",
        cellData: [
          item.sim_type,
          item.icc_id,
          formattedDateTimeBasedOnTimezone(
            item.update_at ?? "",
            tzForDateFns,
            APP_CONFIG.DATETIME_FORMATS.DISPLAY.DATE_TIME
          ),
        ].filter((_, index) => columns[index].show),
      }))
    : [];

  if (modalsState.showModalVMICChistory === false) return null;

  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      />
      <div
        className={
          "fixed inset-y-1/2 inset-x-1/2 w-[calc(100vw-6rem)] h-[calc(100vh-6rem)] bg-black/80 overflow-hidden " +
          "Xbg-white rounded-xl shadow-lg z-modal grid grid-cols-9"
        }
        style={{ transform: "translate(-50%, -50%)" }}
      >
        {/* Close button */}
        <div className="absolute top-4 right-4 flex flex-row gap-2 z-50 p-2 bg-white/20 rounded-full col-span-9">
          <button
            className="group size-10 flex items-center justify-center rounded-full bg-black hover:bg-gray-100 focus:ring focus:ring-white outline-0"
            onClick={hideModal}
          >
            <img
              src={svgIcons.CloseIcon}
              alt="Close"
              className="grayscale-0 brightness-0 invert group-hover:invert-0 opacity-50"
            />
          </button>
        </div>
        <AdminTable
          customWrapperClass="col-span-9 mt-20"
          columns={columns.filter((item) => item.show).map((item) => item.name)}
          data={tableData}
          isLoading={false}
        />
      </div>
    </>
  );
};
export default ModalICCHistory;
